// extracted by mini-css-extract-plugin
export default {"App":"App_App__7iJoo","App-logo":"App_App-logo__OmPnQ","App-logo-spin":"App_App-logo-spin__ohRiP","App-header":"App_App-header__r7D+n","App-link":"App_App-link__Q0pPi"};